import React from 'react';
import JSONTree from 'react-json-tree';

class JsonView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: '',
    };
  }

  render() {
    let { title, data, hideRoot, theme, invertTheme, shouldExpandNode, raw, ...rest } = this.props;
    let { view } = this.state;
    // console.log('view', view);

    return (
      <div style={{ marginBottom: 10, padding: 10 }}>
        <div className='pure-u-g' style={{ padding: 0, margin: 0 }}>
          <div
            className='pure-u-18-24'
            style={{ textAlign: 'left', fontWeight: 600, marginBottom: 0 }}
          >
            {title || (Array.isArray(data) ? 'array' : typeof data)}
          </div>
          <div className='pure-u-6-24' style={{ textAlign: 'right', paddingRight: 20 }}>
            {view === 'JSONTree' || (!view && !raw) ? (
              <a href='javascript:void(0)' onClick={() => this.setState({ view: 'Raw' })}>
                raw
              </a>
            ) : (
              <a href='javascript:void(0)' onClick={() => this.setState({ view: 'JSONTree' })}>
                pretty
              </a>
            )}
          </div>
        </div>
        {view === 'JSONTree' || (!view && !raw) ? (
          <JSONTree
            {...rest}
            data={data}
            hideRoot={hideRoot === undefined ? true : hideRoot}
            theme={theme || defaultTheme}
            invertTheme={invertTheme === undefined ? true : hideRoot}
            shouldExpandNode={shouldExpandNode || jsonTreeShouldExpandNode}
          />
        ) : (
          <pre style={{ height: '100%', overflow: 'none' }}>
            {JSON.stringify(data, undefined, 4)}
          </pre>
        )}
      </div>
    );
  }
}

const defaultTheme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

function jsonTreeShouldExpandNode(levelList, obj, level) {
  // console.log('jsonTreeShouldExpandNode', levelList, obj, level);
  if (level <= 1) { return true; }
  return false;
}

export default JsonView;



// WEBPACK FOOTER //
// ./src/components/JsonView.js